import { render, staticRenderFns } from "./otherInventory.vue?vue&type=template&id=138655ee"
import script from "./otherInventory.vue?vue&type=script&lang=js"
export * from "./otherInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports